/**
 * The add-in's dev-only gate, in one named place.
 *
 * `import.meta.env.DEV` is the convention (see `DevToolsFooter` / `ErrorPanel`):
 * true only under `npm run dev`, false for a build of ANY environment. This
 * wrapper exists because the pane's Jest transform rewrites
 * `import.meta.env.DEV` to the literal `false` before compiling
 * (`jest.importMetaTransform.cjs`), so a component that reads it inline has one
 * branch that no test can ever enter. Going through a module boundary lets a
 * test substitute the answer and exercise BOTH branches — the gate itself and
 * the behaviour behind it.
 *
 * Deliberately not shared with ora: ora's equivalent is
 * `process.env.NODE_ENV !== "production"`, a different expression belonging to
 * a different build system, and neither is correct in the other's bundle.
 */
export function isDevBuild(): boolean {
  return Boolean(import.meta.env.DEV);
}
